// Shared constants for social media logos and corresponding link field names
// This is used across multiple pages to render social link icons
export const SOCIAL_LOGOS = [
  { src: "/logos/solana.svg", linkField: "solana_link" },
  { src: "/logos/website.svg", linkField: "website_link" },
  { src: "/logos/telegram.svg", linkField: "telegram_link" },
  { src: "/logos/x.svg", linkField: "x_link" },
  { src: "/logos/discord.svg", linkField: "discord_link" },
  { src: "/logos/share.svg", linkField: "share", isShare: true },
];
